import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import { useLocation } from "react-router";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Checkbox,
  IconButton,
} from "@mui/material";
import { CREATE_ORDER, ALL_ORDERS } from "../../utils/apiUrl";
import { getApiWithAuth, patchApiWithAuth } from "../../utils/api";
import moment from "moment";
import { styled } from "@mui/system";
import SingleFieldDateRangePicker from "../dateRangePicker/DateRangePicker";
import CustomDropdown from "../CustomDropdown";
import { SearchIcon } from "../Icons";
import { useDisplayMode } from "../../context/DisplayModeContext";

// Redux Imports
import { useSelector, useDispatch } from "react-redux";
import { fetchPharmacies } from "../../slices/pharmacySlice";
import { fetchZones, fetchBoroughs } from "../../slices/zoneSlice";
import { ContainedButton } from "../buttonCompo/Buttons";

const CustomDropdownIcon = styled("img")({
  marginRight: "7px",
  opacity: "0.6",
});

const FILTER_FONT_SIZE = "11.5px";
const FILTER_DROPDOWN_WIDTH = 120;
const FILTER_FONT_WEIGHT = 600;

const FilterComponent = ({
  onFilterData,
  onOrderData,
  buttonData,
  markReadOrderChat,
  fetchOrdersRef,
  statuschild,
  resetTrigger,
  triggerFetch,
  handleMoveDispatch,
  handleBulkCancel,
  handleMoveCheck,
  moveCheck,
  selectAll,
  handleSelectAllOrders
}) => {

  const { displayMode } = useDisplayMode();

  // Local States
  const [timer, setTimer] = useState("");
  const [rx, setrx] = useState("");
  const [boroughs, setBoroughs] = useState("");
  const [filter, setFilter] = useState("");
  const [callToNotify, setCallToNotify] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [dateRange, setDateRange] = useState([
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
    new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000),
  ]);

  const orderObjRef = useRef(null);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");
  const [hasMore, setHasMore] = useState(null);
  const [selectedTab, setSelectedTab] = useState("allOrders");
  const [pharmacy, setPharmacy] = useState("");
  const [zip, setZip] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);


  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const handleChange = (setter) => (value) => {
    setter(value);
  };

  // Function to map button labels to statuses
  const handleStatusChange = (label) => {
    let newStatus = "all";
    switch (label) {
      case "All":
        newStatus = "all";
        break;
      // case "Ready to pick up":
      //   newStatus = "3";
      //   break;
      // case "Pickup Occurred":
      //   newStatus = "2";
      //   break;
      case "Created Orders":
        newStatus = "3";
        break;
      case "In Transit":
        newStatus = "7all";
        break;
      case "Route Created":
        newStatus = "7";
        break;
      case "Failed":
        newStatus = "8";
        break;
      case "Dispatching":
        newStatus = "4";
        break;
      // case "Return Created":
      //   newStatus = "10";
      //   break;
      // case "Return Route Created":
      //   newStatus = "11";
      //   break;
      // case "Return to Pharmacy":
      //   newStatus = "12";
      //   break;
      case "Out for Delivery":
        newStatus = "9";
        break;
      case "Delivered":
        newStatus = "5";
        break;
      case "Canceled":
        newStatus = "6";
        break;
      // case "Cancelled":
      //   newStatus = "6";
      //   break;
      default:
        newStatus = "all";
    }
    return newStatus;
  };

  useEffect(() => {
    if (buttonData?.label) {
      const updatedStatus = handleStatusChange(buttonData.label);
      setStatus(updatedStatus);
      getOrders(updatedStatus);
      fetchFilteredData(dateRange);
    }
  }, [buttonData]);

  useEffect(() => {
    if (statuschild !== null) {
      if (params.has("true")) {
        getOrdersUrgent("3");
        window.history.replaceState(null, "", location.pathname);
      } else {
        getOrders(statuschild);
      }
      setStatus(statuschild);
      onOrderData([]);
      setTotalItems(0);
      setTotalPages(0);
      setPageIndex(1);
      setPageSize(20);
      fetchFilteredData(dateRange);
    }
  }, [statuschild]);

  useEffect(() => {
    if (params.has("true")) {
      getOrdersUrgent("3");
      window.history.replaceState(null, "", location.pathname);
    } else {
      getOrders(status);
    }
    onOrderData([]);
    setTotalItems(0);
    setTotalPages(0);
    setPageIndex(1);
    setPageSize(20);
    fetchFilteredData(dateRange);
  }, [status]);

  useEffect(() => {
    if (triggerFetch) {
      if (params.has("true")) {
        getOrdersUrgent("3");
        window.history.replaceState(null, "", location.pathname);
      } else {
        getOrders(status);
      }
      onOrderData([]);
      setTotalItems(0);
      setTotalPages(0);
      setPageIndex(1);
      setPageSize(20);
      fetchFilteredData(dateRange);
    }
  }, [triggerFetch]);

  const dispatch = useDispatch();

  // Redux State Selectors
  const pharmacyList = useSelector((state) => state.pharmacy.list);
  const pharmacyStatus = useSelector((state) => state.pharmacy.status);
  const pharmacyError = useSelector((state) => state.pharmacy.error);

  const zoneList = useSelector((state) => state.zone.zones);
  const boroughList = useSelector((state) => state.zone.boroughs);
  const zoneStatus = useSelector((state) => state.zone.status);
  const zoneError = useSelector((state) => state.zone.error);

  const userType = localStorage.getItem("userType");
  const pid = localStorage.getItem("pharmacyId");

  useEffect(() => {
    if (userType !== "PharmacyOwner" && userType !== "PharmacyEmployee") {
      if (pharmacyStatus === "idle") {
        dispatch(fetchPharmacies());
      }
      if (zoneStatus === "idle") {
        dispatch(fetchBoroughs());
      }
    }
  }, [userType, dispatch, pharmacyStatus, zoneStatus]);

  const handleBoroughChange = async (value) => {
    if (value !== null) {
      const selectedBoroughId = value;
      setBoroughs(value);
      try {
        const result = await dispatch(fetchZones(selectedBoroughId));
        if (fetchZones.fulfilled.match(result)) {
          const zones = result.payload;
          setSelectedZone(null);
          const zipcodes = zones
            .filter((zone) => zone.zipcode && zone.zipcode.length > 0)
            .flatMap((zone) => zone.zipcode.map((zipcode) => zipcode.zipcode));
          setZip(zipcodes);
        } else {
          console.error("Failed to fetch zones:", result.error.message);
        }
      } catch (error) {
        console.error("Error in handleBoroughChange:", error);
      }
    } else {
      setZip([]);
      setPharmacy("");
      setSelectedZone(null);
    }
  };

  const handleZipChange = (selectedZoneId) => {
    if (selectedZoneId) {
      const selectedZoneObj = zoneList.find(
        (zone) => zone.id === selectedZoneId
      );

      if (selectedZoneObj) {
        const zipcodes = selectedZoneObj.zipcode.map((item) => item.zipcode);
        setZip(zipcodes);
        setSelectedZone(selectedZoneObj);
      } else {
        console.error("Selected zone not found in zoneList.");
        setZip([]);
        setSelectedZone(null);
      }
    } else {
      setZip([]);
      setSelectedZone(null);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const inputValue = e.target.value;
      const searchTerm = inputValue.toLowerCase();
      setSearch(inputValue);
    }
  };

  const fetchFilteredData = async (newDateRange) => {
    try {
      const [startDate, endDate] = newDateRange;
      if (!startDate || !endDate) return;

      const formattedStartDate = moment(startDate).format("MM-DD-YYYY");
      const formattedEndDate = moment(endDate).format("MM-DD-YYYY");

      const response = await getApiWithAuth(
        `${CREATE_ORDER}?from=${formattedStartDate}&to=${formattedEndDate}&callToNotify=${callToNotify}`
      );

      if (response?.data?.data) {
        onFilterData(response.data.data);
        resetTrigger();
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
      resetTrigger();
    }
  };


  const handleDateChange = (newDateRange) => {
    setDateRange(newDateRange);
  };

  let isFetching = false;
  const getOrders = async (
    statusId = status,
    pageIndexData = pageIndex,
    loadMore = false
  ) => {
    console.log("Sssss")
    const [startDate, endDate] = dateRange;
    if (!startDate || !endDate) return;
    const formattedStartDate = moment(startDate).format("MM-DD-YYYY");
    const formattedEndDate = moment(endDate).format("MM-DD-YYYY");
    setLoadingOrder(true);
    if (loadingOrder) return;
    if (isFetching) return;

    isFetching = true;
    const pharmacyParam =
      userType === "PharmacyOwner" || userType === "PharmacyEmployee"
        ? pid
        : `${pharmacy}`;
    if (!loadMore) {
      setPageIndex(1);
    }
    if (callToNotify) {
      setSelectedTab("allOrders");
      const response = await getApiWithAuth(
        ALL_ORDERS +
        `?status=all&pharmacy=${pharmacyParam}&filter=${filter === "0" ? "" : filter
        }&timer=${timer === "0" ? "" : timer
        }&zip=${zip}&from=${formattedStartDate}&to=${formattedEndDate}&callToNotify=${callToNotify}&pageIndex=${!loadMore ? 1 : pageIndexData
        }&pageSize=${pageSize}&search=${search}&rx=${rx}`
      );
      if (response.data !== undefined) {
        if (response.data.data !== undefined) {
          if (loadMore) {
            onOrderData((prevOrders) => [
              ...prevOrders,
              ...response.data.data.data,
            ]);
          } else {
            onOrderData(response.data.data.data);
          }
          setPageIndex((prevPageIndex) => prevPageIndex + 1);
          setHasMore(response.data.data.hasMore);
          setPageSize(response.data.data.pagination.pageSize);
          setTotalPages(response.data.data.pagination.totalPages);
          setTotalItems(response.data.data.pagination.totalItems);
          setLoading(false);
          setLoadingOrder(false);
          isFetching = false;
        } else {
          setLoadingOrder(false);
          setLoading(false);
          isFetching = false;
        }
      } else {
        setLoadingOrder(false);
        setLoading(false);
      }
    } else {
      const pharmacyParam =
        userType === "PharmacyOwner" || userType === "PharmacyEmployee"
          ? pid
          : `${pharmacy}`;
      const response = await getApiWithAuth(
        ALL_ORDERS +
        `?status=${statusId}&pharmacy=${pharmacyParam}&filter=${filter === "0" ? "" : filter
        }&timer=${timer === "0" ? "" : timer
        }&zip=${zip}&from=${formattedStartDate}&to=${formattedEndDate}&pageIndex=${!loadMore ? 1 : pageIndexData
        }&pageSize=${pageSize}&search=${search}&rx=${rx}`
      );
      if (response.data !== undefined) {
        if (response.data.data !== undefined) {
          if (loadMore) {
            onOrderData((prevOrders) => [
              ...prevOrders,
              ...response.data.data.data,
            ]);
          } else {
            onOrderData(response.data.data.data);
          }
          setPageIndex((prevPageIndex) => prevPageIndex + 1);
          setHasMore(response.data.data.hasMore);
          setPageSize(response.data.data.pagination.pageSize);
          setTotalPages(response.data.data.pagination.totalPages);
          setTotalItems(response.data.data.pagination.totalItems);
          setLoadingOrder(false);
          setLoading(false);
        } else {
          setLoadingOrder(false);
          setLoading(false);
        }
      } else {
        setLoadingOrder(false);
        setLoading(false);
      }
      setLoadingOrder(false);
      setLoading(false);
    }
    resetTrigger();
  };


  useImperativeHandle(fetchOrdersRef, () => async (loadMore = false) => {
    await getOrders(status, pageIndex, loadMore);
  });

  const getOrdersUrgent = async (pageIndexData = pageIndex) => {
    // setLoading(true);
    const pharmacyParam =
      userType === "PharmacyOwner" || userType === "PharmacyEmployee"
        ? pid
        : `${pharmacy}`;
    const response = await getApiWithAuth(
      ALL_ORDERS +
      `?status=1&pharmacy=${pharmacyParam}&filter=${filter === "0" ? "" : filter
      }&timer=Urgent&zip=${zip}&pageIndex=${pageIndexData}&pageSize=${pageSize}&search=${search}&rx=${rx}`
    );
    if (response.data !== undefined) {
      if (response.data.data !== undefined) {
        onOrderData(response.data.data.data);
        setPageIndex(response.data.data.pagination.nextPageIndex);
        setPageSize(response.data.data.pagination.pageSize);
        setTotalPages(response.data.data.pagination.totalPages);
        setTotalItems(response.data.data.pagination.totalItems);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (params.has("true")) {
      getOrdersUrgent("3");
      window.history.replaceState(null, "", location.pathname);
      setSelectedTab("readyToPickup");
    } else {
      fetchFilteredData(dateRange);
      getOrders();
    }
  }, [search, rx, pharmacy, zip, dateRange, filter, timer, callToNotify, location]);

  const renderMenuItem = (value, label) => (
    <MenuItem key={value} value={value} sx={{ fontSize: FILTER_FONT_SIZE }}>
      {label}
    </MenuItem>
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {(status === "3" || status === "4" || status === "7all" || status === "7" || status === "8" || status === "9") && <Checkbox
          autoComplete="off"
          type="checkbox"
          checked={moveCheck}
          onChange={() => handleMoveCheck()}
          style={{ transform: "scale(0.8)" }}
        />}
        {displayMode === "large" && (
          <TextField
            variant="outlined"
            autoComplete="off"
            placeholder="Search Order Id, Name, Phone, Address, RX#"
            InputProps={{
              sx: {
                fontSize: `${FILTER_FONT_SIZE}`,
                fontWeight: FILTER_FONT_WEIGHT,
              },
              onKeyDown: handleKeyPress,
              endAdornment: (
                <IconButton>
                  <SearchIcon />
                </IconButton>
              ),
            }}
            sx={{
              mr: 2,
              minWidth: 250,
              height: 36,
              backgroundColor: "#fff",
              borderRadius: "15px",
              boxShadow: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: "5px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            size="small"
          />
        )}

        {userType !== "PharmacyOwner" && userType !== "PharmacyEmployee" && (
          <div style={{ marginRight: "10px" }}>
            <CustomDropdown
              customstyles={{
                height: "36px",
                width: "137px",
              }}
              label="Filter Pharmacy"
              value={pharmacy}
              onChange={(selected) => setPharmacy(selected)}
              options={pharmacyList.map((pharm) => ({
                value: pharm.id,
                label: pharm.name,
              }))}
              isMultiSelect={true}
            />
          </div>
        )}
        {userType !== "PharmacyOwner" && userType !== "PharmacyEmployee" && (
          <div style={{ marginRight: "10px" }}>
            <CustomDropdown
              customstyles={{
                height: "36px",
                width: "137px",
              }}
              label="Select Borough"
              value={boroughs}
              onChange={handleBoroughChange}
              options={boroughList.map((boro) => ({
                value: boro.id,
                label: boro.name,
              }))}
              isMultiSelect={false}
            />
          </div>
        )}
        {userType !== "PharmacyOwner" && userType !== "PharmacyEmployee" && (
          <div style={{ marginRight: "10px" }}>
            <CustomDropdown
              customstyles={{
                height: "36px",
                width: "137px",
              }}
              label="Select Zone"
              value={selectedZone ? selectedZone.id : ""}
              onChange={handleZipChange}
              options={zoneList.map((zon) => ({
                value: zon.id,
                label: zon.name,
              }))}
              isMultiSelect={false}
            />
          </div>
        )}
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
          <CustomDropdown
            customstyles={{
              height: "36px",
              width: FILTER_DROPDOWN_WIDTH,
            }}
            label="Select Filter"
            value={filter}
            onChange={handleChange(setFilter)}
            options={[
              { value: 1, label: "Refrigerator" },
              { value: 2, label: "Photo Id" },
              { value: 3, label: "Copay" },
            ]}
            isMultiSelect={false}
          />
          <CustomDropdown
            customstyles={{
              height: "36px",
              width: "120px",
            }}
            label="Time Window"
            value={timer}
            onChange={(value) => setTimer(value)}
            options={[
              { value: "Anytime", label: "Anytime" },
              { value: "9am-3pm", label: "9am-3pm" },
              { value: "2pm-6pm", label: "2pm-6pm" },
              { value: "5pm-9pm", label: "5pm-9pm" },
              { value: "Urgent", label: "Urgent" },
            ]}
            isMultiSelect={false}
          />
        </Box>

        {userType !== "PharmacyOwner" && userType !== "PharmacyEmployee" && (
          <Button
            variant="outlined"
            sx={{
              ml: 1,
              border: "none",
              backgroundColor: "#EDEFF1",
              borderRadius: "5px",
              color: "#000",
              textTransform: "none",
              fontSize: `${FILTER_FONT_SIZE}`,
              fontWeight: FILTER_FONT_WEIGHT,
              height: 36,
            }}
            onClick={() => setCallToNotify(!callToNotify)}
            endIcon={
              <img
                src="/icons/Info.svg"
                alt="Info icon"
                style={{ opacity: 0.6 }}
              />
            }
          >
            Call to Notify
          </Button>
        )}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", mr: 4 }}>
        {moveCheck && (
          <>
            <ContainedButton
              label={selectAll ? "UnSelect All" : "Select All"}
              borderRadius="8px"
              onClick={handleSelectAllOrders}
              margin="0 10px 0 0"
              sx={{
                backgroundColor: "#fb1001",
                color: "white",
                borderRadius: "8px",
                padding: "6px 12px",
                minWidth: "auto",
                fontSize: "12px",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#fb1001",
                },
              }}
            />
            <ContainedButton
              label="Cancel"
              borderRadius="8px"
              onClick={handleMoveCheck}
              margin="0 10px 0 0"
              sx={{
                backgroundColor: "#fb1001",
                color: "white",
                borderRadius: "8px",
                padding: "6px 12px",
                minWidth: "auto",
                fontSize: "12px",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#fb1001",
                },
              }}
            />
            {status === "8" &&
              <ContainedButton
                label={"Cancel Order"}
                borderRadius="8px"
                onClick={handleBulkCancel}
                sx={{
                  backgroundColor: "#0B6699",
                  color: "white",
                  borderRadius: "8px",
                  padding: "6px 12px",
                  minWidth: "auto",
                  fontSize: "12px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#08517B",
                  },
                }}
              />}
            <ContainedButton
              label={status === "3" ? "Move to dispatch" : "Move to created"}
              borderRadius="8px"
              onClick={handleMoveDispatch}
              sx={{
                backgroundColor: "#0B6699",
                color: "white",
                borderRadius: "8px",
                padding: "6px 12px",
                minWidth: "auto",
                fontSize: "12px",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#08517B",
                },
              }}
            />
          </>
        )}
        <SingleFieldDateRangePicker
          value={dateRange}
          onChange={handleDateChange}
        />
      </Box>
    </Box>
  );
};

export default forwardRef(FilterComponent);
